<template>
  <modal name="credit-cards-list" :width="520">
    <div>
      <header class="modal-header center-md center-xs py15 px65 h1 sans-serif weight-700 bg-cl-secondary flex">
        <span>{{ $t('Purse') }}</span>
        <i slot="close" class="modal-close material-icons p15 cl-bg-tertiary" @click="close" data-testid="closeModalButton">
          close
        </i>
      </header>
      <div class="modal-content px30 pt0">
        <credit-cards-list />
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../../Modal'
import CreditCardsList from './CreditCardsList'

export default {
  name: 'ModalCreditCardsList',
  components: {
    Modal,
    CreditCardsList
  },
  methods: {
    close () {
      this.$bus.$emit('modal-hide', 'credit-cards-list')
    }
  }
}
</script>
